import { render, staticRenderFns } from "./ErsatzDialogComp.vue?vue&type=template&id=2c3718b4&scoped=true&"
import script from "./ErsatzDialogComp.vue?vue&type=script&lang=ts&"
export * from "./ErsatzDialogComp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3718b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VAutocomplete,VCard,VDialog})
